
export const SENT_CREATEEMPLOYEREMAIL_STARTED = "SENT_CREATEEMPLOYEREMAIL_STARTED";
export const SENT_CREATEEMPLOYEREMAIL_SUCESS = "SENT_CREATEEMPLOYEREMAIL_SUCESS";
export const SENT_CREATEEMPLOYEREMAIL_FAILED = "SENT_CREATEEMPLOYEREMAIL_FAILED";

export const SENT_CREATEEMPLOYEEEMAIL_STARTED = "SENT_CREATEEMPLOYEEEMAIL_STARTED";
export const SENT_CREATEEMPLOYEEEMAIL_SUCESS = "SENT_CREATEEMPLOYEEEMAIL_SUCESS";
export const SENT_CREATEEMPLOYEEEMAIL_FAILED = "SENT_CREATEEMPLOYEEEMAIL_FAILED";

export const SENT_CREATECASEEMAIL_STARTED = "SENT_CREATECASEEMAIL_STARTED";
export const SENT_CREATECASEEMAIL_SUCESS = "SENT_CREATECASEEMAIL_SUCESS";
export const SENT_CREATECASEEMAIL_FAILED = "SENT_CREATECASEEMAIL_FAILED";

export const SENT_EMPLOYMENTCREATION_STARTED = "SENT_EMPLOYMENTCREATION_STARTED";
export const SENT_EMPLOYMENTCREATION_SUCESS = "SENT_EMPLOYMENTCREATION_SUCESS";
export const SENT_EMPLOYMENTCREATION_FAILED = "SENT_EMPLOYMENTCREATION_FAILED";

export const employerSetupEmail = (emailTemplateInput: any) => {
   
    return {
        type: SENT_CREATEEMPLOYEREMAIL_STARTED,
        payload: 'status',
        input: emailTemplateInput
    };
};

export const employeeAccountCreationEmail = (emailTemplateInput: any) => {
   
    return {
        type: SENT_CREATEEMPLOYEEEMAIL_STARTED,
        payload: 'status',
        input: emailTemplateInput
    };
};

export const sendCaseCreationEmail = (emailTemplateInput: any) => {
   
    return {
        type: SENT_CREATECASEEMAIL_STARTED,
        payload: 'status',
        input: emailTemplateInput
    };
};

export const employmentCreation = (emailTemplateInput: any) => {
   
    return {
        type: SENT_EMPLOYMENTCREATION_STARTED,
        payload: 'status',
        input: emailTemplateInput
    };
};
